import React from "react";
import { PublicLayout } from "@/components/site/PublicLayout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <PublicLayout>
      <section className="mx-auto max-w-2xl px-4 sm:px-6 lg:px-8 pt-24 pb-24">
        <div className="kicker">404</div>
        <h1 className="mt-3 font-display text-5xl sm:text-6xl font-extrabold tracking-[-0.03em] text-[color:var(--coh-ink)]">Not found</h1>
        <p className="mt-3 text-[color:var(--coh-ink-muted)]">This page moved, was archived, or never existed.</p>
        <Button asChild className="btn-nb btn-nb-primary h-11 px-6 mt-6">
          <Link to="/">Back home <span aria-hidden="true" className="font-mono ml-1">↗</span></Link>
        </Button>
      </section>
    </PublicLayout>
  );
}
